<template>
    <div class="navbar" ref="navbar">
        <router-link to="/">Home</router-link>
        <router-link :to="{ name: 'Work' }">Work</router-link>
        <router-link :to="{ name: 'Academics' }">Academics</router-link>
        <router-link :to="{ name: 'Projects' }">Projects</router-link>
        <router-link :to="{ name: 'Art' }">Art</router-link>
        <router-link :to="{ name: 'Personal' }">Personal</router-link>
    </div>
</template>


<script>
export default {
    methods: {
        getHeight() {
            return this.$refs.navbar.offsetHeight;
        }
    }
}
</script>


<style scoped>
    .navbar {
    overflow: hidden;
    display: block;
    background-color: purple;
    border: 8px ridge magenta;
    top: 0; /* Position the navbar at the top of the page */
    width: fill; /* Full width */
    padding-left: 2px;
    }

    /* Links inside the navbar */
    .navbar a {
    float: left;
    display: inline-block;
    color: lightcyan;
    background: darkmagenta;
    text-align: center;
    font-weight: bold;
    font-size: 1.1em;
    min-width: 8em;
    margin: 0px 2px;
    padding: 15px 15px;
    text-decoration: none;
    }

    /* Change background on mouse-over */
    .navbar a:hover {
    background: lightcyan;
    color: black;
    }

    @media screen and (max-width: 1080px) {
        .navbar {
            padding: 3px;
        }
        .navbar a {
            width: calc(33% - 34px);
            margin: 3px 3px;
            min-width: 0;
        }
    }

    @media screen and (max-width: 633px) {
        .navbar {
            padding: 3px;
        }
        .navbar a {
            width: calc(33% - 5px);
            margin: 3px 3px;
            padding: 15px 0px;
        }
    }

    @media screen and (max-width: 333px) {
        .navbar {
            padding: 1px;
        }
        .navbar a {
            width: fill;
            margin: 1px 1px;
            padding: 2px 2px;
        }
    }
</style>